import { NgModule } from "@angular/core";
import { HighchartsChartModule } from "highcharts-angular";
import { AdvancedChartComponent } from "./components/advanced-chart/advanced-chart.component";
import { LineChartComponent } from "./components/line-chart/line-chart.component";
import { ColumnChartComponent } from "./components/column-chart/column-chart.component";
import { CoreModule } from "@modules/core/core.module";
import { AreaChartComponent } from "@modules/shared/chart/components/area-chart/area-chart.component";
import { SimpleChartComponent } from "./components/simple-chart/simple-chart.component";
import { LineChartSmallComponent } from "@modules/shared/chart/components/line-chart-small/line-chart-small.component";

const components = [
	AdvancedChartComponent,
	LineChartComponent,
	ColumnChartComponent,
	SimpleChartComponent,
	AreaChartComponent,
	LineChartSmallComponent
];

@NgModule({
	imports: [CoreModule, HighchartsChartModule],
	declarations: [components],
	exports: [components]
})
export class ChartModule {}
